import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './GroupLeaderboard.css'; // Ensuring shared styles for consistency
import { Link } from 'react-router-dom';

const GratitudeLeaderboard = () => {
    const [leaderboard, setLeaderboard] = useState([]);
    const [sortBy, setSortBy] = useState("currentStreak"); // Default sorting
    const [search, setSearch] = useState(''); // Search input state
    const logoPath = "/images/gratiSphere.svg";

    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                const response = await axios.get(`https://wholeness-forward.onrender.com/api/leaderboard/gratitude-leaderboard?sortBy=${sortBy}`);
                console.log("📊 Fetched Gratitude Data:", response.data);
                setLeaderboard(response.data);
            } catch (error) {
                console.error("❌ Error fetching gratitude leaderboard:", error);
            }
        };

        fetchLeaderboard();
    }, [sortBy]);

    // Sort users based on selected criterion
    const sortedUsers = [...leaderboard].sort((a, b) => {
        return (b.gratitudeStats?.[sortBy] || 0) - (a.gratitudeStats?.[sortBy] || 0);
    });

    // Assign ranks based on sorting
    const usersWithRank = sortedUsers.map((user, index) => ({
        ...user,
        rank: index + 1, // Rank based on sorted position
    }));

    // Search filter (preserves rank)
    const filteredUsers = usersWithRank.filter(user =>
        user?.username?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="group-page-container">
            {/* Header with logo */}
            <img src={logoPath} alt="GratiSphere Logo" className="leader-logo" />
            <h1 className="group-title">GratiSphere Leaderboard</h1>

            <div className="micro-void"></div>

            <div className="leaderboard-section">
                <h3>Individual Gratitude Rankings</h3>

                {/* Sorting Dropdown */}
                <div className="timeframe-selector">
                    <label>Sort by:</label>
                    <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                        <option value="currentStreak">🔥 Current Streak</option>
                        <option value="longestStreak"><img src={logoPath} alt="GratiSphere Logo" className="icon-smallest" /> Longest Streak</option>
                        <option value="totalDays">📅 Total Days</option>
                    </select>
                </div>

                {/* Search Bar */}
                <input
                    type="text"
                    placeholder="Search by username"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="search-bar"
                />

                {/* Leaderboard Table */}
                <table className="mini-leaderboard-table">
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Username</th>
                            <th>Current Streak 🔥</th>
                            <th>Longest Streak <img src={logoPath} alt="GratiSphere Logo" className="icon-smallest" /></th>
                            <th>Total Days 📅</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.length === 0 ? (
                            <tr><td colSpan="5">No data available</td></tr>
                        ) : (
                            filteredUsers.map((user) => (
                                <tr key={user._id}>
                                    <td># {user.rank}</td> {/* Rank */}
                                    <td>{user.username}</td> {/* Username */}
                                    <td>{user.gratitudeStats.currentStreak} 🔥</td> {/* Current Streak */}
                                    <td>{user.gratitudeStats.longestStreak} <img src={logoPath} alt="GratiSphere Logo" className="icon-smaller" /> </td> {/* Longest Streak */}
                                    <td>{user.gratitudeStats.totalDaysRecorded} 📅</td> {/* Total Days */}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className="micro-void"></div>
            {/* 🔙 Back to Main Leaderboard */}
            <Link to="/leaderboard" className="leaderboard-link">← Back to Main Leaderboard</Link>
            <div className="micro-void"></div>

        </div>
    );
};

export default GratitudeLeaderboard;
